import React from 'react'
import {
  Box,
  Typography,
  Card,
  CardContent,
  Alert,
} from '@mui/material'

const SettingsPage: React.FC = () => {
  return (
    <Box>
      <Typography variant="h4" component="h1" gutterBottom>
        設定
      </Typography>
      
      <Card>
        <CardContent>
          <Alert severity="info">
            設定機能は実装中です。通知設定やパスワード変更がここに表示されます。
          </Alert>
        </CardContent>
      </Card>
    </Box>
  )
}

export default SettingsPage